import * as React from 'react';
import {
  Dialog,
  DialogContent,
  Grid,
  Button,
  Typography,
} from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

interface CourierRescanModalProps {
  onClose: () => void;
  open: boolean;
  bin: string;
}

const useStyles = makeStyles((theme) => createStyles({
  rescanButton: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
    },
  },
}));
const CourierRescanModal: React.FC<CourierRescanModalProps> = ({
  onClose, bin, open,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      onClose={onClose}
      open={open}
      fullWidth
      maxWidth="sm"
    >
      <DialogContent>
        <Grid container direction="row-reverse" spacing={1}>
          <Grid item xs={12}>
            <Typography style={{ fontSize: '1rem' }} variant="subtitle1">
              {'RESCAN DROPPED OFF ITEMS'}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" style={{ color: '#587B9F', fontWeight: 700 }}>
              {'Rescan items into Temporary bin'}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography display="inline" style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: '0.875rem' }} variant="subtitle1">
              {'Take the Temporary bin and dump the repairs back in the bin they started in, '}
            </Typography>
            <Typography display="inline" style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: '0.875rem', fontWeight: 900 }} variant="subtitle2">
              {`${bin},`}
            </Typography>
            <Typography display="inline" style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: '0.875rem' }} variant="subtitle1">
              {' and rescan the repairs into the Temporary bin'}
            </Typography>
          </Grid>
          <Grid item>
            <Button
              id="begin-rescan-button"
              color="secondary"
              variant="contained"
              onClick={onClose}
              className={classes.rescanButton}
            >
              {'BEGIN RESCAN'}
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default CourierRescanModal;
